var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifiyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1140_372)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.514 19.9525L33.6722 29.8364L33.0856 39.3873L5.25703 23.6955L13.4322 18.4243L19.2754 8.53896C22.5021 3.08149 29.6491 1.20996 35.2357 4.36329C40.8251 7.51369 42.7406 14.4936 39.514 19.9525ZM15.5193 37.7197C13.4234 36.5376 12.7047 33.9211 13.9147 31.8736L21.5047 36.1534C20.2947 38.2008 17.6151 38.9004 15.5193 37.7197ZM36.6979 1.89053C29.7122 -2.04747 20.7787 0.288892 16.7454 7.11329L10.9037 16.9972L0.00195312 24.0284L11.3862 30.448C9.36954 33.8595 10.5649 38.2213 14.0585 40.1896C17.5521 42.1608 22.0181 40.9918 24.0347 37.5804L35.4176 44L36.2022 31.262L42.0439 21.3781C46.0773 14.5552 43.6837 5.83146 36.6979 1.89053Z",
    fill: "#6E3EF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1140_372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifiyIcon);
export default __webpack_public_path__ + "static/media/notifiyIcon.ef86a3f2e8658226f5cd9dfaa38db0c3.svg";
export { ForwardRef as ReactComponent };